import { useEffect } from "react"

interface Props {
	title: string
}

export function MetaInfo({ title }: Props) {
	useEffect(() => {
		document.title = title ? `${title} | Productlane` : "Productlane"
	}, [title])

	return null
}
